import React, { useMemo } from "react";
import MdaeDrawer from "../drawer";
import {
  initialSystemMessagePopupFormData,
  SET_AREA_TYPE_FILTER_LIST_CHECKBOXES,
  SET_CURRENT_SELECTED_MODULE,
  TOGGLE_NOTIFICATION_AREA_TYPE_FILTER_POPOVER,
  TOGGLE_NOTIFICATION_PANEL,
} from "./reducers/notification-and-system-messages-reducer";
import { useDispatch, useSelector } from "react-redux";
import NotificationComponent, {
  setNotificationsDataGridFilter,
  toggleDocumentGridCheckboxes,
  toggleNotificaionAndSystemMsgGridSearchPanel,
} from "./notification-component";
import MdaeButton from "../button";
import "./index.scss";
import { isEqual } from "lodash";
import { bindActionCreators } from "redux";
import { callOperation, actions as asyncActions } from "async-ops";
import { DELETE_NOTIFICATIONS } from "./services/delete-notifications";
import { GET_NOTIFICATIONS } from "./services/get-notifications";
import MdaePopover from "../popover";
import MdaeList from "../list";
import {
  notificationfiltersDataArray,
  NOTIFICATION_AND_SYSTEM_MODULE_STATES,
} from "./constants";
import SystemMessagesComponent, {
  toggleAddSystemMessagePopupVisible,
} from "./system-messages-component";
import {
  resetMessagesPopupFormData,
  SYSTEM_MESSAGES_POPUP_MODES,
} from "./add-system-message-popup";
import { getUserPermissionObject } from "../../user-permissions-helper";
import $ from "jquery";
import {
  hasAnyInternalAuditWorkFlowAccess,
  hasWorkflowAccess
} from "../../../common_components/user-permissions-helper";
import { CODER_WORKFLOW ,EXTERNAL_WORKFLOW} from "../../user-permissions-helper";

interface INotificationAndSystemModuleProps {
  children?: React.ReactNode;
}
const NofiticationsAndSystemMessagesWrapperComponent = () => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const systemMessagePermissions = getUserPermissionObject(
    "SYSTEM_MESSAGES",
    currentUser
  );
  const notificationGridSelection = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"]
        .notificationGridSelectionObject.mode,
    isEqual
  );
  const isDeleteNotificationBtnVisible = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"]
        .isDeleteNotificationBtnVisible,
    isEqual
  );
  const notificationGridSelectedRowKeys = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"]
        .notificationGridSelectedRowKeys,
    isEqual
  );
  const isNotificationAndSystemMessagesGridSearchPanelVisible = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"]
        .isNotificationAndSystemMessagesGridSearchPanelVisible,
    isEqual
  );
  const notificationsAreaTypeFilterItems = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"]
        .notificationsAreaTypeFilterItems,
    isEqual
  );
  const notificationsDataGridFilter = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"].notificationsDataGridFilter,
    isEqual
  );
  const systemMessageList: any[] = useSelector(
    (state) => state["notificationAndSystemMessagesReducer"].systemMessageList,
    isEqual
  );
  const notificationList: any[] = useSelector(
    (state) => state["notificationAndSystemMessagesReducer"].notificationList,
    isEqual
  );
  const currentSelectedModule: string = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"].currentSelectedModule,
    isEqual
  );
  const _authorized: boolean = useSelector(
    (state) => state["notificationAndSystemMessagesReducer"].isAuthorized,
    isEqual
  );
  const setCurrentSelectedModule = (module) => {
    dispatch({
      type: SET_CURRENT_SELECTED_MODULE,
      data: {
        currentSelectedModule: module,
      },
    });
  };
  const togglenotificationAreaTypeFilterPopover = (isVisible, target) => {
    dispatch({
      type: TOGGLE_NOTIFICATION_AREA_TYPE_FILTER_POPOVER,
      data: {
        notificationAreaTypeFilterPopoverTarget: target,
        isNotificationAreaTypeFilterPopoverVisible: isVisible,
      },
    });
  };
  const hasInternalWorkFlowAccess = useMemo(
    () => hasAnyInternalAuditWorkFlowAccess(currentUser),
    [currentUser]
  );
  const hasCoderWorkFlowAcess = useMemo(
    () => hasWorkflowAccess([CODER_WORKFLOW],currentUser),[currentUser]
  )
  const hasExternalWorkFlowAcess = useMemo(
    () => hasWorkflowAccess([EXTERNAL_WORKFLOW],currentUser),[currentUser]
  )
  const getNotificationDataSourceList = () => {

    var notificationDataSourceList = notificationfiltersDataArray;
    if (!hasInternalWorkFlowAccess) {
      notificationDataSourceList = notificationDataSourceList?.filter(x => x.text != "Audit Creation" && x.text != "QA Review");
    }
    if (!hasCoderWorkFlowAcess) {
      notificationDataSourceList = notificationDataSourceList?.filter(x => x.text != "Coder Review");
    }
    if (!hasExternalWorkFlowAcess) {
      notificationDataSourceList = notificationDataSourceList?.filter(x => x.text != "esMD");
    }

    return notificationDataSourceList;
  }
  const getNotificationFilterTypepopover = () => {
    return (
      <>
        {" "}
        <MdaeList
          id="pnlNotificationAreaTypeFilterActionPopover"
          className="notification-area-type-popover-list mdae-menu-list-popover mdae-compact-dx-list"
          style={{ width: 200 }}
          dataSource={getNotificationDataSourceList()}
          selectAllMode="allPages"
          selectionMode="all"
          showSelectionControls={true}
          itemRender={(data) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center" }}
                title={data.text}
              >
                <div
                  className={data.iconClassName}
                  style={{ marginLeft: "6px" }}
                ></div>
                <div style={{ marginLeft: "10px" }}>{data.text}</div>
              </div>
            );
          }}
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_AREA_TYPE_FILTER_LIST_CHECKBOXES,
              reducerName: "notificationAndSystemMessagesReducer",
              widgetOptionBindings: {
                selectedItemKeys: "notificationsAreaTypeFilterItems",
              },
            },
          ]}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderTop: "1px solid grey",
            padding: "none",
          }}
        >
          <MdaeButton
            id="btnNotificationAreaFilterTooltipCancel"
            role="dxButton"
            className="mdae-secondary-button"
            stylingMode="text"
            text="Cancel"
            onClick={() => {
              togglenotificationAreaTypeFilterPopover(false, null);
            }}
          />
          <MdaeButton
            id="btnNotificationAreaFilterTooltipOk"
            role="dxButton"
            className="mdae-secondary-button"
            stylingMode="text"
            text="OK"
            onClick={() => {
              let filterArray = [];
              for (var item of notificationsAreaTypeFilterItems) {
                filterArray.push(["notificationArea", "=", item.text]);
                filterArray.push("or");
              }
              setNotificationsDataGridFilter(dispatch, filterArray);
              togglenotificationAreaTypeFilterPopover(false, null);
            }}
          />
        </div>
      </>
    );
  };

  return (
    <div className="notification-and-system-messages-wrapper-panel">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
        className="application-section-primary-background-color title-text"
      >
        <div style={{ width: "70%", color: "white" }}>
          Messages &amp; Notifications
        </div>
        <div
          id="pnlNotificationMessagesToolbar"
          style={{
            width: "30%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {currentSelectedModule ===
            NOTIFICATION_AND_SYSTEM_MODULE_STATES.SYSTEM_MESSAGES_MODULE && (
            <>
              <MdaeButton
                id="btnAddMessage"
                role="dxButton"
                icon="white-icon-button fa fa-plus"
                stylingMode="text"
                visible={_authorized}
                onClick={() => {
                  toggleAddSystemMessagePopupVisible(
                    dispatch,
                    true,
                    "Add New Message",
                    SYSTEM_MESSAGES_POPUP_MODES.ADD,
                    initialSystemMessagePopupFormData
                  );
                  resetMessagesPopupFormData(dispatch);
                }}
              />
              <MdaeButton
                id="btnToggleNotificationAndMessageSearch"
                role="dxButton"
                icon="white-icon-button fa fa-search"
                stylingMode="text"
                onClick={() => {
                  toggleNotificaionAndSystemMsgGridSearchPanel(
                    dispatch,
                    !isNotificationAndSystemMessagesGridSearchPanelVisible
                  );
                }}
              />
            </>
          )}
          {currentSelectedModule ===
            NOTIFICATION_AND_SYSTEM_MODULE_STATES.NOTIFICATION_MODULE && (
            <>
              <MdaePopover
                id="pnlNotificationsAreaTypeFilterPopover"
                className="notification-area-type-popover"
                onShowing={(e) => {
                  $("#pnlNotificationAreaTypeFilterActionPopover")
                    .parents(".dx-popup-content")
                    .removeClass("dx-popup-content");
                }}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: TOGGLE_NOTIFICATION_AREA_TYPE_FILTER_POPOVER,
                    reducerName: "notificationAndSystemMessagesReducer",
                    widgetOptionBindings: {
                      target: "notificationAreaTypeFilterPopoverTarget",
                      visible: "isNotificationAreaTypeFilterPopoverVisible",
                    },
                  },
                ]}
              >
                {getNotificationFilterTypepopover()}
              </MdaePopover>
              <MdaeButton
                id="btnToggleNotificationAndMessageSearch"
                role="dxButton"
                icon="white-icon-button fa fa-search"
                stylingMode="text"
                onClick={() => {
                  toggleNotificaionAndSystemMsgGridSearchPanel(
                    dispatch,
                    !isNotificationAndSystemMessagesGridSearchPanelVisible
                  );
                }}
              />
              <MdaeButton
                visible={isDeleteNotificationBtnVisible}
                id="btnNotificationDelete"
                role="dxButton"
                icon="white-icon-button delete-action-white-icon"
                stylingMode="text"
                onClick={() => {
                  callOperation(
                    DELETE_NOTIFICATIONS,
                    notificationGridSelectedRowKeys?.map(
                      (x) => x.notificationId
                    )
                  ).then((reponse) => {
                    if (reponse) {
                      asyncAction.asyncOperationStart(GET_NOTIFICATIONS);
                    }
                  });
                }}
              />

              <MdaeButton
                id="btnToggleNotificationAreaTypeFilterPopover"
                role="dxButton"
                icon={(() => {
                  let className =
                    "white-icon-button notification-area-type-filter-icon";
                  if (!isEqual(notificationsDataGridFilter, []))
                    className += " notification-toolbar-icon-selected";
                  return className;
                })()}
                stylingMode="text"
                onClick={(e) => {
                  togglenotificationAreaTypeFilterPopover(true, e.element);
                }}
              />
              <MdaeButton
                id="btnToggleNotificationSelection"
                role="dxButton"
                icon="white-icon-button fa fa-check-square-o"
                stylingMode="text"
                onClick={() => {
                  toggleDocumentGridCheckboxes(
                    dispatch,
                    notificationGridSelection
                  );
                }}
              />
            </>
          )}
        </div>
      </div>
      <div className="notification-and-syatem-messages-view">
        <div className="notification-and-system-message-toggle-ui title-text">
          <div
            id="pnlNotificationsCount"
            role="button"
            className={(() =>
              currentSelectedModule ===
              NOTIFICATION_AND_SYSTEM_MODULE_STATES.NOTIFICATION_MODULE
                ? "toggle-tab-item application-section-primary-color"
                : "toggle-tab-item")()}
            onClick={() => {
              setCurrentSelectedModule(
                NOTIFICATION_AND_SYSTEM_MODULE_STATES.NOTIFICATION_MODULE
              );
            }}
          >
            <span className="clickable-item">
              {" "}
              {"Notifications " +
                "(" +
                notificationList.filter((x) => !x?.isNotificationRead).length +
                ")"}
            </span>
          </div>
          <div
            id="pnlSystemMessagesCount"
            role="button"
            className={(() =>
              currentSelectedModule ===
              NOTIFICATION_AND_SYSTEM_MODULE_STATES.SYSTEM_MESSAGES_MODULE
                ? "toggle-tab-item application-section-primary-color"
                : "toggle-tab-item")()}
            onClick={() => {
              setCurrentSelectedModule(
                NOTIFICATION_AND_SYSTEM_MODULE_STATES.SYSTEM_MESSAGES_MODULE
              );
            }}
          >
            <span className="clickable-item">
              {" System Messages " + "(" + systemMessageList?.length + ")"}
            </span>
          </div>
        </div>
        <div>
          <NotificationComponent
            visible={
              currentSelectedModule ===
              NOTIFICATION_AND_SYSTEM_MODULE_STATES.NOTIFICATION_MODULE
            }
          />
          <SystemMessagesComponent
            visible={
              currentSelectedModule ===
              NOTIFICATION_AND_SYSTEM_MODULE_STATES.SYSTEM_MESSAGES_MODULE
            }
            permissions={systemMessagePermissions}
          />
        </div>
      </div>
    </div>
  );
};
export const toggleNotificationsPanelOpen = (
  isNotificationPanelOpen,
  dispatch
) => {
  dispatch({
    type: TOGGLE_NOTIFICATION_PANEL,
    data: {
      isNotificationPanelOpen: !isNotificationPanelOpen,
    },
  });
};
const NotificationAndSystemModule: React.FC<INotificationAndSystemModuleProps> = (
  props
) => {
  const isNotificationPanelOpen = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"].isNotificationPanelOpen,
    isEqual
  );

  return (
    <MdaeDrawer
      id="pnlNotificationsAndSystemMessages"
      openedStateMode={"overlap"}
      position={"right"}
      revealMode={"slide"}
      component={NofiticationsAndSystemMessagesWrapperComponent}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_NOTIFICATION_PANEL,
          reducerName: "notificationAndSystemMessagesReducer",
          widgetOptionBindings: {
            opened: "isNotificationPanelOpen",
          },
        },
      ]}
    >
      {props.children}
    </MdaeDrawer>
  );
};

export default NotificationAndSystemModule;
